import { Box, styled } from '@mui/material';

export const StyledHelpTabListContainer = styled(Box)(({ theme }) => ({
  '& > *': {
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
  },
}));
